


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// Components
import Tabs from "../../../components/Tabs.vue";
import AccItemDimensionView from "./AccItemDimensionView.vue";
import VatAnalytics from "../components/VatAnalytics.vue";
import VatItemEdit from "../components/VatItemEdit.vue";
import FlowReviewGrid from "./FlowReviewGrid.vue";
import ExcelFileBrowser from "@/modules/excel-test/components/ExcelFileBrowser.vue";
import ExpandableSection from "@/components/ExpandableSection.vue";
import IconButton from "@/components/IconButton.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import ColspanFixer from "@/components/ColspanFixer.vue";
import Tooltip from "@/components/Tooltip.vue";
import ButtonCheckBox from "@/components/ButtonCheckBox.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";

// Models
import Vue from "vue";
import eventBus from "@/services/eventBus";
import InvoiceFlowApi from "../services/InvoiceFlowApi";
import CurrencyRateApi from "@/modules/currencyRate/services/CurrencyRateApi";
import store, { FlowStatus, InvoiceFlowStore } from "../services/InvoiceFlowStore";
import permStore, {
  InvoicePermissions,
  PermissionStore,
} from "@/services/permissions";
import itemStore, {
  InvoiceItemStore,
} from "@/modules/invoiceItems/services/store";
import VatDivision, {
  VatDivisionModifier,
  VatDivisionModifierDefProps,
} from "@/modules/invoiceFlow/models/VatDivision";
import IncomingInvoiceAccItem, {
  incomingInvoiceAccItemDefaultProps,
} from "../models/IncomingInvoiceAccItem";
import VatDivisionDisplay, {
  vatDivDispDefaultProps,
} from "../models/VatDivisionDisplay";
import AccInvSError from "../models/AccInvSError";
import { deepCopy } from "@/utils/objects";
import { InvoiceItemsTable } from "@/modules/invoiceItems";

import configuration, {
  AppConfiguration,
  loadConfiguration,
} from "@/models/Configuration";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import VatReturnStatus from "@/modules/vat/models/VatReturnStatus";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import ConfirmationBox from "@/components/ConfirmationBox.vue";
import { PermitStatuses } from "@/modules/generalIngoingInvoice/models/PermitStatus";
import editStore, {
  GeneralIngoingInvoiceEditModelStore,
} from "@/modules/generalIngoingInvoiceEditModel/services/GeneralIngoingInvoiceEditModelStore";
import DateInput from "@/components/DateInput.vue";
import AccrualView from "@/modules/accrual/views/AccrualView.vue";
import AccrualApi from "@/modules/accrual/services/AccrualApi";
import prodPurchaseStore, { ProdPurchaseStore } from "@/modules/prodPurchase/services/ProdPurchaseStore";
import { t } from "@/plugins/i18n";

class AccCode {
  value = "";
  name = "";
}

class LedgerSummaryItem {
  isDemand = false;
  accCode = "";
  total = 0;
  currTotal = 0;
  currency = "";
  exchangeRate = 1;
  color = "";
}

interface Data {
  store: InvoiceFlowStore;
  permStore: PermissionStore;
  prodPurchaseStore: ProdPurchaseStore;
  tab: null | number;
  accrualCount: number;
  accrualTabKeepOpen: boolean;
  accountItemGroupOrder: string[];
  showErrorList: boolean;
  backupItem: IncomingInvoiceAccItem;
  inEdit: boolean;
  itemIDToDelete: number;
  deleting: boolean;
  dim1editing: boolean;
  backupDim1: string;
  newItem: IncomingInvoiceAccItem;
  isNewItem: boolean;
  changedVatDivs: VatDivision[];
  editingVat: boolean;
  itemStore: InvoiceItemStore;
  modifiedVatItem: VatDivisionModifier;
  updateVatStore: boolean;
  filterShowExcel: boolean;
  ledgerSummaryView: boolean;
  statusColorMap: Record<number, string>;
  vatDateChangeVisible: boolean;
  uninvoicedDelivery: boolean;
  loading: boolean;
  accountingPrecision: number;
  configuration: AppConfiguration;
  reassureCashAccountingDialog: boolean;
  showShipDateConfirmation: boolean;
  shipDateConfirmed: boolean;
  shipDateChangeRequired: boolean;
  vatDate: string;
  vatDateErrorMessage: string;
  vatDateInfoMessage: string;
  vatDatePromptMessage: string;
  vatDatePrompt: boolean;
  editStore: GeneralIngoingInvoiceEditModelStore;
  vatDateClosed: boolean;
  confirmReCalcVatItems: boolean;
  confirmAccrualRecount: boolean;
}

interface Methods {
  updatePermitStatuses(): void;
  updateWithReCalcVatItems(): void;
  updateWithAccrualRecount(): Promise<void>;
  update(reCalcVatItems?: boolean | false): Promise<void | boolean>;
  setInEdit(dataItem: IncomingInvoiceAccItem): void;
  cancelEdit(dataItem: IncomingInvoiceAccItem): void;
  saveEdit(dataItem: IncomingInvoiceAccItem): void;
  setExpanded(dataItem: IncomingInvoiceAccItem): void;
  isDimensions(dataItem: IncomingInvoiceAccItem): boolean;
  preAccounting(): Promise<void>;
  postAccounting(): Promise<void>;
  showErrors(): void;
  setDelete(dataItem: IncomingInvoiceAccItem): void;
  cancelDelete(): void;
  confirmDelete(): void;
  setDimEdit(dataItem: IncomingInvoiceAccItem): void;
  saveDimEdit(dataItem: IncomingInvoiceAccItem): void;
  cancelDimEdit(dataItem: IncomingInvoiceAccItem): void;
  setNewItem(): void;
  cancelNewItem(): void;
  confirmNewItem(): void;
  cancelAccounting(): void;
  addItemToChanged(dataItem: VatDivisionDisplay): void;
  saveVatDivItems(): void;
  saveVatDivs(x: VatDivision): Promise<void>;
  editVatItem(): void;
  saveVatDivChange(itemToSave: VatDivisionModifier): Promise<any>;
  saveVatDivChanges(): void;
  reload(invoiceId: number): Promise<any>;
  toggleInverseVatSummary(): void;
  setService(): void;
  currencyChanged(dataItem: IncomingInvoiceAccItem): void;
  totalChanged(dataItem: IncomingInvoiceAccItem): void;
  reopen(): void;
  copy(): void;
  getMarginUnderStockGroup(
    h: any,
    trElement: any,
    defaultSlots: any,
    props: any
  ): any;
  tartozikStockGroupClass(item: IncomingInvoiceAccItem): string;
  kovetelStockGroupClass(item: IncomingInvoiceAccItem): string;

  showUninvoicedDelivery(stock: number): void;
  hasNote(item: IncomingInvoiceAccItem): boolean;
  updateCashAccounting(): void;
  refresh(): Promise<void>;
  loadAccrualCount(): Promise<void>;
  saveVatDate(isWarningChecked: boolean): void;
  printProdPurchasePdf(): void;
}

interface Computed {
  noAccountPerm: boolean;
  isPageDisabled: boolean;
  invoiceId: number;
  accountItems: IncomingInvoiceAccItem[];
  accInvSErrors: AccInvSError[];
  changeVatDivisionButtonText: string;
  hasErrors: boolean;
  columns: any[];
  accCodes: AccCode[];
  ledgerSummaryItems: LedgerSummaryItem[];
  hufInvoice: boolean;
  isOtherItemRelation: boolean;
  newItemValidation: string;
  isModifyDisabled: boolean;
  showAccrualTab: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    Tabs,
    AccItemDimensionView,
    VatAnalytics,
    VatItemEdit,
    FlowReviewGrid,
    ExcelFileBrowser,
    ExpandableSection,
    IconButton,
    MoneyInput,
    ColspanFixer,
    Tooltip,
    ButtonCheckBox,
    MoneyDisplay,
    InvoiceItemsTable,
    ValidationError,
    ConfirmationBox,
    DateInput,
    AccrualView,
  },

  created() {
    eventBus.$on("FlowAccountingPage:preAccounting", this.preAccounting);
  },
  beforeDestroy() {
    eventBus.$off("FlowAccountingPage:preAccounting", this.preAccounting);
  },

  async mounted() {
    this.loading = true;
    this.store.accountingTabItem = 1;

    try {
      await loadConfiguration();

      this.accountingPrecision =
        configuration?.getCurrDigits(this.store.invoice.invCurrency)
          ?.accountingDigits ?? 0;

      //Ezek egymástól függetlenek, párhuzamosan indíthatók
      await Promise.all([
        this.store.loadAccountItems(Number(this.$route.params.invoiceId)),
        this.store.getAccInvSErrors(Number(this.$route.params.invoiceId)),
        this.store.accItemDetailedTypes.length < 1
          ? this.store.getAccItemDetailedTypes()
          : Promise.resolve(),
        this.store.currencies.length == 0
          ? this.store.loadCurrencies()
          : Promise.resolve(),
      ]);
      /* await this.reload(this.invoiceId); */

      await this.loadAccrualCount();

      //Van hogy nem jó a státusza a számlának, ez frissíti a státuszt.
      //A kontír tételeket épp most mentettük, ezért csak a számla fejet és a hibalistát
      //olvassuk újra: a teljes refresh() feleslegesen futtatná le újra a legdrágább lekérdezést.
      if (this.store.invoice.accStatus == 5 || this.store.invoice.accStatus == 2) {
        await this.store.updateAccountItems(this.store.invoice.id, this.accountItems);
        await Promise.all([
          this.store.loadInvoiceWithoutBusy(this.store.invoice.id),
          this.store.getAccInvSErrors(this.store.invoice.id),
        ]);

        if (this.hasErrors) {
          this.showErrorList = true;
        }
      }

      this.vatDateClosed = false;
      if (this.store.invoice.vatDate) {
          const shippingDatePhase = await this.store.getInvoiceShippingPhaseDate();
          if (shippingDatePhase.id !== 1) {
            this.vatDateClosed = shippingDatePhase.statusID === VatReturnStatus.Closed;
          }
        }

    } finally {
      this.loading = false;
    }
  },

  data: () => ({
    editingVat: false,
    updateVatStore: false,
    modifiedVatItem: VatDivisionModifierDefProps,
    itemStore,
    permStore,
    store,
    prodPurchaseStore,
    changedVatDivs: [],
    stockDivisionItems: [],
    tab: 0,
    accrualCount: 0,
    // Elhatárolás törlés után a fül nyitva marad, hogy a felhasználó rögtön válthasson tételesre
    accrualTabKeepOpen: false,
    accountItemGroupOrder: ["Partner", t("Afa"), t("Keszlet")],
    showErrorList: false,
    backupItem: { ...incomingInvoiceAccItemDefaultProps },
    inEdit: false,
    itemIDToDelete: 0,
    deleting: false,
    dim1editing: false,
    backupDim1: "",
    newItem: { ...incomingInvoiceAccItemDefaultProps },
    isNewItem: false,
    filterShowExcel: false,
    ledgerSummaryView: false,
    statusColorMap: {
      1: "primary white--text",
      8: "red white--text",
      7: "red white--text",
    },
    vatDateChangeVisible: false,
    confirmAccrualRecount: false,
    uninvoicedDelivery: false,
    loading: false,
    accountingPrecision: 0,
    configuration,
    reassureCashAccountingDialog: false,
    showShipDateConfirmation: false,
    shipDateConfirmed: false,
    shipDateChangeRequired: false,
    vatDate: '',
    vatDateErrorMessage: '',
    vatDateInfoMessage: '',
    vatDatePromptMessage: '',
    vatDatePrompt: false,
    editStore,
    vatDateClosed: false,
    confirmReCalcVatItems: false,
  }),

  computed: {
    newItemValidation() {
      if (this.newItem.detailedTypeID < 2)
        return t("InvoiceFlow_KotelezoKivalasztaniATetelTipusat");
      if (
        Number(this.newItem.total) === 0 &&
        Number(this.newItem.currTotal) === 0 &&
        Number(this.newItem.totalDemand) === 0 &&
        Number(this.newItem.currTotalDemand) === 0
      )
        return t("InvoiceFlow_KotelezoKitolteniAKovetelVagyTartozik");
      if (
        this.newItem.accCode.length < 1 &&
        this.newItem.accCodeDemand.length < 1
      )
        return t("InvoiceFlow_KotelezoKitolteniAKovetelVagyTartozik_2");

      return "";
    },

    changeVatDivisionButtonText() {
      return this.editingVat ? "Vissza" : t("InvoiceFlow_AfaBontasModositasa");
    },

    // Csak akkor van elhatárolás fül, ha időszakos elszámolású ügyleten kérték is az elhatárolást.
    // A darabszám feltétel biztonsági háló: a korábbi adatokon maradt elhatárolás így nem válik elérhetetlenné.
    showAccrualTab() {
      // accrualTabKeepOpen: a felhasználó szándékosan törölte az elhatárolást (pl. tételesre akar váltani),
      // a fül ne tűnjön el rögtön, hogy ne kelljen visszamenni a fejhez és újra bepipálni
      return (
        (this.store.invoice.shipDateC && this.store.invoice.isAccrual) ||
        this.accrualCount > 0 ||
        this.accrualTabKeepOpen
      );
    },

    isPageDisabled() {
      return (
        !this.permStore.hasAccounting() ||
        !this.permStore.hasInvoice([InvoicePermissions.Accounting]) ||
        this.store.invoice.accStatus == 6 ||
        this.loading
      );
    },

    isModifyDisabled(){
      return (
        !this.permStore.hasAccounting() ||
        !this.permStore.hasInvoice([InvoicePermissions.Accounting]) ||
        this.loading
      );
    },

    noAccountPerm(){
      return !this.permStore.hasAccounting();
    },

    invoiceId() {
      return Number(this.$route.params.invoiceId);
    },

    accountItems() {
      let result = [...this.store.accountItems];
      result = result.concat([...this.store.caroAccountItems]);      

      const newList: IncomingInvoiceAccItem[] = [];
      const items: IncomingInvoiceAccItem[] = [];

      const groupAccessor = this.ledgerSummaryView
        ? (item: IncomingInvoiceAccItem) => item.accCode || item.accCodeDemand
        : (item: IncomingInvoiceAccItem) => item.detailedType;

      const sortAccessor = this.ledgerSummaryView
        ? (item: IncomingInvoiceAccItem) => item.accCode || item.accCodeDemand
        : (item: IncomingInvoiceAccItem) =>
            this.accountItemGroupOrder.indexOf(item.detailedType);

      result.sort((a, b) => (sortAccessor(a) > sortAccessor(b) ? 1 : 0));

      /* console.log("raw items");
      console.log(result);
      console.log("--------"); */

      //Csoportonként az első tétel id-je, illetve id -> tétel: a soronkénti result.find() helyett
      const firstIdByGroup = new Map<string, number>();
      const itemById = new Map<number, IncomingInvoiceAccItem>();
      result.forEach((i) => {
        const group = groupAccessor(i);
        if (!firstIdByGroup.has(group)) {
          firstIdByGroup.set(group, i.id);
        }
        if (!itemById.has(i.id)) {
          itemById.set(i.id, i);
        }
      });

      const newListIds = new Set<number>();

      result.forEach((i) => {
        //head = a group's first item
        const group = groupAccessor(i);
        i.group = group;
        i.head = i.id === firstIdByGroup.get(group);

        //For stock items if it has a invoiceitem-item, the original item's id is the item-item's groupWith prop
        if (i.groupWith > 1) {
          const f = itemById.get(i.groupWith);
          i.groupClass = "groupStock";
          newList.push(i);
          newListIds.add(i.id);
          if (f) {
            f.groupClass = "groupStockItem";
            newList.push(f);
            newListIds.add(f.id);
          }
        } else if (!newListIds.has(i.id)) {
          newList.push(i);
          newListIds.add(i.id);
        }
      });

      //the stock group's first item is the head
      const stockHeads = newList.filter(
        (x) => x.group == this.accountItemGroupOrder[2] && x.head
      );
      //every other item, which is not stock group, can be pushed into the array
      const notStock = newList.filter(
        (x) => x.group != this.accountItemGroupOrder[2]
      );

      //Egy tétel csak egyszer kerülhet be. Korábban minden sor többször is bekerült, és a
      //végén egy háromszorosan egymásba ágyazott ciklus szedte ki a duplikátumokat (O(n^3)).
      const pushedIds = new Set<number>();
      const pushOnce = (item: IncomingInvoiceAccItem) => {
        if (pushedIds.has(item.id)) {
          return;
        }
        pushedIds.add(item.id);
        items.push(item);
      };

      notStock.forEach((x) => {
        pushOnce(x);
      });

      //a new row for stock groups (just for rendering)
      const emptyRow = incomingInvoiceAccItemDefaultProps;
      emptyRow.accCode = "placehold";
      emptyRow.group = this.accountItemGroupOrder[2];
      emptyRow.head = true;

      //adding new rows for every kind of group (for rendering)
      if (stockHeads.length > 0) {
        const firstIndexByItem = new Map<IncomingInvoiceAccItem, number>();
        newList.forEach((x, index) => {
          if (!firstIndexByItem.has(x)) {
            firstIndexByItem.set(x, index);
          }
        });

        //a készlet csoport első fej sorának indexétől kezdődik a felsorolás
        const firstHeadIndex = stockHeads.reduce(
          (min, x) => Math.min(min, firstIndexByItem.get(x) ?? 0),
          newList.length
        );

        for (let i = firstHeadIndex; i < newList.length; i++) {
          if (i === firstHeadIndex) {
            pushOnce(emptyRow);
          }
          newList[i].head =
            newList[i].group === "Készlet" ? false : newList[i].head;
          pushOnce(newList[i]);
        }
      }

      /* console.log("result items");
      console.log(items.map(x=>x.note)); */
      return items;
    },

    accInvSErrors() {
      return this.store.accInvSErrors;
    },

    hasErrors() {
      return this.accInvSErrors.length > 0;
    },

    columns() {
      const _columns = [
        {
          width: 30,
          cell: "expandDetailTemplate",
        },
        {
          cell: "typeTemplate",
          width: 80,
          headerCell: "typeHeaderTemplate",
        },
        {
          field: "accCode",
          title: t("Tartozik"),
          cell: "tartozikTemplate",
          headerCell: "headerIncomeTemplate",
        },
        {
          width: 150,
          field: "total",
          title: t("Osszeg"),
          cell: "tartozikTotalTemplate",
          headerCell: "headerIncomeTemplate",
        },
        {
          width: 150,
          field: "currTotal",
          title: t("InvoiceFlow_OsszegDeviza"),
          cell: "tartozikCurrTotalTemplate",
          headerCell: "headerIncomeTemplate",
        },
        {
          field: "accCodeDemand",
          title: t("Kovetel"),
          cell: "kovetelTemplate",
          headerCell: "headerDemandTemplate",
        },
        {
          width: 150,
          field: "totalDemand",
          title: t("Osszeg"),
          cell: "kovetelTotalTemplate",
          headerCell: "headerDemandTemplate",
        },
        {
          width: 150,
          field: "currTotalDemand",
          title: t("InvoiceFlow_OsszegDeviza"),
          cell: "kovetelCurrTotalTemplate",
          headerCell: "headerDemandTemplate",
        },
        {
          field: "accDate",
          title: t("KonyvelesDatuma"),
          headerClassName: "font-weight-bold grey--text text--darken-3",
          cell: "accDateTemplate",
          width: 100,
        },
        { width: 50, cell: "commandsTemplate" },
      ];

      // Insert separator column
      const separatorIndex = this.hufInvoice ? 4 : 5;
      _columns.splice(separatorIndex, 0, {
        width: 5,
        cell: "separatorTemplate",
      });

      if (this.hufInvoice) {
        return _columns.filter(
          (c) => !["currTotal", "currTotalDemand"].includes(c.field || "")
        );
      }

      return _columns;
    },

    hufInvoice() {
      return this.store.invoice.invCurrency === "HUF";
    },

    accCodes() {
      return this.store.accCodes.map((x) => ({
        value: x.code,
        name: `${x.code} - ${x.accName}`,
      }));
    },

    ledgerSummaryItems() {
      const list: LedgerSummaryItem[] = this.store.accountItems.map((i) => ({
        isDemand: i.isDemand,
        accCode: i.isDemand ? i.accCodeDemand : i.accCode,
        total: i.isDemand ? i.totalDemand ?? 0 : i.total ?? 0,
        currTotal: i.isDemand ? i.currTotalDemand ?? 0 : i.currTotal ?? 0,
        currency: i.currency,
        exchangeRate: i.exchangeRate ?? 1,
        color: i.isDemand ? "#f99142" : "#3db6ef",
      }));

      const result: LedgerSummaryItem[] = [];

      list.forEach((x) => {
        const item = result.find(
          (y) => x.accCode == y.accCode && x.isDemand == y.isDemand
        );

        if (item) {
          item.total += x.total;
          item.currTotal += x.currTotal;
          if (item.exchangeRate == 1 && x.exchangeRate > 1) {
            item.currency = x.currency;
            item.exchangeRate = x.exchangeRate;
          }
        } else {
          result.push({
            isDemand: x.isDemand,
            accCode: x.accCode,
            total: x?.total ?? 0,
            currTotal: x?.currTotal ?? 0,
            currency: x.currency,
            exchangeRate: x.exchangeRate,
            color: x.color,
          });
        }
      });

      return result.sort((a, b) => Number(a.accCode) - Number(b.accCode));
    },

    isOtherItemRelation() {
      return this.store.invoice.type == 6;
    },
  },

  watch: {
    async invoiceId(value: number) {
      await this.reload(value);
    },

    ledgerSummaryView(value: boolean) {
      eventBus.$emit("FlowAccountingPage:ledgerSummaryView:changed", value);
    },

    vatDateChangeVisible(){
      this.vatDate = this.store.invoice.vatDate || '';
    }
  },

  methods: {
    async updatePermitStatuses(): Promise<void> {
      if (this.store.invoice.permitStatus == PermitStatuses.Payable) {
        eventBus.$emit("error", t("InvoiceFlow_ASzamlaMarFizetheto"));
      }
      else if (!this.store.flowStatusRelations.filter((y) => !y.deleted).map((x) => x.statusId).includes(FlowStatus.StockRelationRecording)) {
        eventBus.$emit("error", t("InvoiceFlow_ASzamlaNincsJovahagyva"));
      }
      else {
        await this.editStore.updatePermitStatuses([this.store.invoice.id], PermitStatuses.Payable);
        eventBus.$emit("success", t("SikeresUtalvanyozasStatuszAllitas"));
      }
    },

    saveVatDate(isWarningChecked: boolean){
      this.vatDateErrorMessage = '';
      this.vatDateInfoMessage = '';
      this.vatDatePromptMessage = '';
      this.vatDatePrompt = false;

      InvoiceFlowApi.vatDateUpdate(this.store.invoice.id, this.vatDate, isWarningChecked).then(checkResponse => {
        if (checkResponse.isError){
          this.vatDateErrorMessage = checkResponse.message;
          console.log(this.vatDateErrorMessage);
        } else if (checkResponse.isInfo){
          this.vatDateInfoMessage = checkResponse.message;
          this.refresh();
        } else if (checkResponse.isYesNo){
          this.vatDatePromptMessage = checkResponse.message;
          this.vatDatePrompt = true;
        }
      });
    },

    async refresh() {
      try {
        this.loading = true;
        await this.reload(Number(this.$route.params.invoiceId));
        // Az elhatárolás mentés/törlés után is változhat (pl. az időszakos jelölés
        // levételekor a backend törli), ezért a fül állapotát is frissíteni kell.
        await this.loadAccrualCount();
      } finally {
        this.loading = false;
      }
    },

    // A mentett elhatárolás tételszáma: számla szintű, illetve ha az nincs, tétel szintű
    async loadAccrualCount() {
      const invoiceId = Number(this.store.invoice.id);
      if (!invoiceId) {
        this.accrualCount = 0;
        return;
      }

      const accrual = await AccrualApi.get("geni", invoiceId);
      this.accrualCount = accrual.items?.length ?? 0;
      if (this.accrualCount == 0) {
        const itemAccruals = await AccrualApi.getItems("geni", invoiceId);
        this.accrualCount = itemAccruals.reduce((acc, a) => acc + (a.items?.length ?? 0), 0);
      }
    },

    async updateCashAccounting() {
      store.invoice.isCashAccounting = false;
      await this.update();
      await this.postAccounting();
    },

    hasNote(item) {
      if (item && item.note && item.note.length > 1) {
        return item.note.toLowerCase().includes("ár");
      }
      return false;
    },

    async showUninvoicedDelivery(stock: number) {
      this.uninvoicedDelivery = !this.uninvoicedDelivery;
      await this.store.loadUninvoicedDelivery(stock);
    },

    kovetelStockGroupClass(item: IncomingInvoiceAccItem) {
      if (item.isDemand) {
        return item.groupClass;
      } else {
        return "";
      }
    },

    tartozikStockGroupClass(item: IncomingInvoiceAccItem) {
      if (!item.isDemand) {
        return item.groupClass;
      } else {
        return "";
      }
    },

    getMarginUnderStockGroup(h, trElement, defaultSlots, props) {
      let k = "";
      if (props.dataItem.groupClass == "groupStockItem") {
        k = "groupStockMargin";
      }

      const trProps = {
        class: k,
      };

      return h("tr", trProps, defaultSlots);
    },

    async reload(invoiceId: number) {
      if (invoiceId <= 1) {
        return;
      }

      await Promise.all([
        this.store.loadInvoiceWithoutBusy(invoiceId),
        this.store.getAccItemDetailedTypes(),
        this.store.loadAccountItems(invoiceId),
        this.store.setVatAnalitycsStore(invoiceId),
        this.store.getAccInvSErrors(invoiceId),
      ]);

      if (this.hasErrors) {
        this.showErrorList = true;
      }
    },

    setDimEdit(dataItem) {
      this.backupDim1 = dataItem.dimCode1;

      dataItem.dim1Edit = true;
      this.dim1editing = true;
    },

    cancelDimEdit(dataItem) {
      dataItem.dimCode1 = this.backupDim1;
      dataItem.dim1Edit = false;
      this.dim1editing = false;
    },

    async saveDimEdit(dataItem) {
      await this.store.updateAccountItem(dataItem);
      dataItem.dim1Edit = false;
      this.dim1editing = false;
    },

    setDelete(dataItem) {
      this.itemIDToDelete = dataItem.id;
      this.deleting = true;
    },

    async confirmDelete() {
      await this.store.deleteAccountItem(this.itemIDToDelete);

      const item = this.store.accountItems.find(
        (x) => x.id == this.itemIDToDelete
      );
      if (item) {
        const index = this.store.accountItems.indexOf(item);
        this.store.accountItems.splice(index, 1);
        this.store.accountItems = [...this.store.accountItems];
      }

      this.deleting = false;
    },

    cancelDelete() {
      this.deleting = false;
    },

    showErrors() {
      this.showErrorList = !this.showErrorList;
    },

    async preAccounting() {
      try {
        this.loading = true;

        // Ha a mentés nem sikerült (pl. elhatárolás validációs hiba), nem szabad újrakontírozni
        if ((await this.update()) === false) return;

        await this.store.preAccounting(this.invoiceId);
        await this.reload(this.invoiceId);
        await this.store.loadFlowActionLogs(
          Number(this.$route.params.invoiceId)
        );
        eventBus.$emit("success", t("InvoiceFlow_AKontirozasSikeresenLefutott"));
      } catch (ex) {
        console.log(ex);
        eventBus.$emit("Hiba történt az automatikus kontírozás közben!");
        throw ex;
      } finally {
        this.loading = false;
      }
    },

    async cancelAccounting() {
      try {
        this.loading = true;
        eventBus.$emit("invoice-accounting:saving", true);
        await this.store
          .cancelAccounting(this.invoiceId)
          .then(async (result) => {
            await this.store
              .loadInvoice(this.store.invoice.id)
              .then(async () => await this.reload(this.invoiceId));

            if (result.code >= 0) {
              eventBus.$emit(
                "success",
                t("InvoiceFlow_ASzamlaVisszaveteleFokonyvbolMegtortent")
              );
              await this.store.resetFlowStatusRelations(this.invoiceId);
              await this.store.loadFlowStatusRelations(this.invoiceId);
              await this.store.loadFlowActionLogs(this.invoiceId);
            } else {
              eventBus.$emit(
                "error",
                t("InvoiceFlow_CodeIpCodeSqlErrIsam", [result.err, result.code, result.ipCode, result.sqlErr, result.isam])
              );
            }
          });
      } catch (ex) {
        console.log(ex);
        throw ex;
      } finally {
        this.loading = false;
        eventBus.$emit("invoice-accounting:saving", false);
      }
    },

    async postAccounting() {
      try {
        //Ha az áfa dátum már lezárt áfa időszakban van akkor figyelmeztetni kell a felhasználót
        if (this.store.invoice.vatDate) {
          const shippingDatePhase = await this.store.getInvoiceShippingPhaseDate();
          if (shippingDatePhase.id !== 1) {
            this.showShipDateConfirmation = shippingDatePhase.statusID === VatReturnStatus.Closed;

            if (!this.showShipDateConfirmation) {
              const shippingDateErrorMsg = t("InvoiceFlow_SzamlaTeljesitesiDatumaNyitottAfaPeriodusba");
              eventBus.$emit("warn", shippingDateErrorMsg);
              this.shipDateConfirmed = true;
            }
          }
        }

        if (this.showShipDateConfirmation && !this.shipDateConfirmed) {
          return;
        }

        this.loading = true;
        eventBus.$busy(true);
        eventBus.$emit("invoice-accounting:saving", true);
        await this.store.updateAccountItems(this.store.invoice.id, this.accountItems);
        const result = await this.store.postAccounting(this.invoiceId);
        if (Number(result.sqlErr) === 0 && result.err.length < 1) {
          eventBus.$emit("success", t("InvoiceFlow_ASzamlaFeladasaMegtortent"));
          this.$invoiceTaskUpdateHub.send("InvoiceTaskUpdated");
          // this.$emit("update");
          await this.store.manageFlowStatusRelations(this.store.invoice.id);
        } else {
          eventBus.$emit(
            "error",
            t("InvoiceFlow_CodeIpCodeSqlErrIsam", [result.err, result.code, result.ipCode, result.sqlErr, result.isam])
          );
        }
      } catch (e) {
        console.log(e);
        throw e;
      } finally {
        eventBus.$busy(false);
        this.loading = false;
        eventBus.$emit("invoice-accounting:saving", false);
        await this.refresh();
      }
    },

    isDimensions(item) {
      const accCodeContains =
        item.accCode.startsWith("5") ||
        item.accCode.startsWith("8") ||
        item.accCode.startsWith("9");
      const accCodeDemandContains =
        item.accCodeDemand.startsWith("5") ||
        item.accCodeDemand.startsWith("8") ||
        item.accCodeDemand.startsWith("9");

      return accCodeContains || accCodeDemandContains;
    },

    setInEdit(dataItem) {
      this.backupItem = deepCopy(dataItem);
      const item = this.store.accountItems.find((i) => i.id === dataItem.id);

      if (item) {
        item.inEdit = true;
        this.inEdit = true;
        this.store.accountItems = [...this.store.accountItems];
      }
    },

    setNewItem() {
      this.newItem = { ...incomingInvoiceAccItemDefaultProps };
      this.newItem.accDate = this.store.invoice.accDate || "";
      this.isNewItem = true;
    },

    cancelNewItem() {
      this.isNewItem = false;
    },

    async confirmNewItem() {
      const type = this.store.accItemDetailedTypes.find(
        (x) => x.id == this.newItem.detailedTypeID
      );
      if (type) {
        this.newItem.detailedType = type.name;
      }

      console.log(this.newItem);

      await this.store.createAccountItem(this.newItem).then((id) => {
        this.newItem.id = id;
        // this.store.accountItems.push(this.newItem);
        this.store.accountItems = [...this.store.accountItems, this.newItem];
        this.isNewItem = false;
      });
      await this.reload(Number(this.$route.params.invoiceId));
      await this.store.loadAccountItems(Number(this.$route.params.invoiceId));
    },

    cancelEdit(dataItem) {
      const item = this.store.accountItems.find((i) => i.id === dataItem.id);
      if (item) {
        Object.assign(item, { ...this.backupItem, inEdit: false });
        this.inEdit = false;
      }
    },

    async saveEdit(dataItem) {
      const item = this.store.accountItems.find((i) => i.id === dataItem.id);
      if (item) {
        await this.store.updateAccountItem(item);
        item.inEdit = false;
        this.inEdit = false;
      }
    },

    setExpanded(dataItem) {
      dataItem.expanded = !dataItem.expanded;
      this.store.accountItems = [...this.store.accountItems];
    },

    async updateWithReCalcVatItems() {
      await this.preAccounting();
    },

    // Az elhatárolás fülön a kontírozott számla mentése -> újrakontírozás megerősítés után
    async updateWithAccrualRecount() {
      await this.preAccounting();
    },

    async update() {
      this.loading = true;

      if (
        this.store.accountingTabItem == 2 &&
        (this.store.invoice.accStatus == 6 || !this.confirmAccrualRecount)
      ) {
        this.confirmAccrualRecount = true;
        this.loading = false;
        return;
      }

      if (this.store.reCalcVatItems && !this.confirmReCalcVatItems) {
        this.confirmReCalcVatItems = true;
        return;
      }
      if (this.store.runPreAccounting && !this.confirmReCalcVatItems) {
        this.confirmReCalcVatItems = true;
        return;
      }

      try {
        await this.store.changeInVatCount(
          this.store.vatDivisionItemGroups.flatMap((i) => i.items),
          this.store.reCalcVatItems
        );
        eventBus.$emit("invoice-accounting:saving", true);
        //await this.store.updateFlow(this.isOtherItemRelation, true);
        switch (this.store.accountingTabItem) {
          default:
          case 1:
            await this.store.updateAccountItems(
              this.store.invoice.id,
              this.accountItems
            );
            eventBus.$emit("success", t("SikeresMentes"));
            break;
          case 2:
            // Sikertelen elhatárolás mentés esetén jelezzük a hívónak, hogy az újrakontírozás ne fusson le
            if (!(await (this.$refs.accrualView as any)?.save())) {
              return false;
            }
            break;
          case 3:
            
            if (!this.editingVat) {
              this.saveVatDivItems();
            } else if (this.editingVat) {
              this.saveVatDivChanges();
            }
            this.changedVatDivs = [];
            break;
        }
      } catch (ex) {
        console.log(ex);
        throw ex;
      } finally {
        this.loading = false;
        this.store.reCalcVatItems = false;
        this.store.runPreAccounting = false;
        this.confirmReCalcVatItems = false;
        this.confirmAccrualRecount = false;
        eventBus.$emit("invoice-accounting:saving", false);
        await this.refresh();
      }
    },

    async saveVatDivChanges() {
      try {
        const d = VatDivisionModifierDefProps;
        for (const element of this.itemStore.itemList.items) {
          d.invoiceItemId = element.invoiceItemID;
          d.invoiceId = Number(this.$route.params.invoiceId);
          d.vatDivisionId = element.tax.vatItemID;
          await this.saveVatDivChange(d);
        }
        eventBus.$emit("success", t("SikeresMentes"));
        await InvoiceFlowApi.runVatDividing(
          Number(this.$route.params.invoiceId)
        );
        this.editingVat = false;
      } catch {
        eventBus.$emit("error");
      }
    },

    async saveVatDivChange(itemToSave: VatDivisionModifier) {
      await InvoiceFlowApi.saveVatDivChanges(itemToSave);
    },

    addItemToChanged(dataItem: VatDivisionDisplay) {      

      const vatDivTemp = this.store.vatDivisions.find(d => d.id == dataItem.id);
      if (vatDivTemp) {
        vatDivTemp.isInvest = dataItem.isInvest;
        vatDivTemp.backDemand = dataItem.backDemand;
        vatDivTemp.substractable = dataItem.substractable;
        if ([11,12].includes(vatDivTemp.tax)) {
          vatDivTemp.tax2 = dataItem.tax2
          vatDivTemp.netto = dataItem.netto;
          vatDivTemp.vat = dataItem.vat;
          vatDivTemp.brutto = dataItem.brutto;
        }

        const index = this.changedVatDivs.findIndex(e => e.id === vatDivTemp.id);
        if (index !== -1) {
          this.changedVatDivs[index] = { ...this.changedVatDivs[index], ...vatDivTemp };
        } else {
          this.changedVatDivs.push(vatDivTemp);
        }
      }
    },

    async saveVatDivItems() {
      if (this.changedVatDivs.length > 0) {
        await this.changedVatDivs.forEach((x) => {          
          this.saveVatDivs(x ?? vatDivDispDefaultProps);
        });
        eventBus.$emit("success", t("InvoiceFlow_SikereseMentes"));
      }
    },

    async saveVatDivs(x: VatDivision) {
      try {
        if (x.id != 1) {
          await InvoiceFlowApi.saveVatDivisionItem(x);
        }
      } catch {
        eventBus.$emit("error", t("NemSikerultAMentes"));
      }
    },

    editVatItem() {
      this.editingVat = !this.editingVat;
      this.store;
    },

    toggleInverseVatSummary() {
      eventBus.$emit("toggle-inv-vat-summary");
    },

    async setService() {
      await this.store.setService().then(() => {
        if (this.store.invoice.invCurrency != "HUF") location.reload();
      });
    },

    async currencyChanged(dataItem: IncomingInvoiceAccItem) {
      dataItem.exchangeRate = await CurrencyRateApi.getRateOnDate(
        dataItem.currency,
        this.store.invoice.rateDate
      );
      this.totalChanged(dataItem);
    },

    totalChanged(dataItem: IncomingInvoiceAccItem) {
      if (!dataItem.exchangeRate) return;

      if (dataItem.total != null && dataItem.currTotal != null) {
        dataItem.total = this.store.toDecimal(
          dataItem.currTotal * dataItem.exchangeRate,
          4
        );
      }

      if (dataItem.totalDemand != null && dataItem.currTotalDemand != null) {
        dataItem.totalDemand = this.store.toDecimal(
          dataItem.currTotalDemand * dataItem.exchangeRate,
          4
        );
      }
    },

    async reopen() {
      try {
        this.loading = true;
        eventBus.$emit("invoice-accounting:saving", true);
        const success = await this.store.reopen();

        if (success) {
          window.location.reload();
        }
      } catch (ex) {
        console.log(ex);
        throw ex;
      } finally {
        this.loading = false;
        eventBus.$emit("invoice-accounting:saving", false);
      }
    },

    async copy() {
      const success = await this.store.copy();
      if (success > 1) {
        this.$router.push(`/general-incoming-invoice/flow/edit/${success}/2`)
      }
    },

    async printProdPurchasePdf() {
      try {
        this.loading = true;
        await this.prodPurchaseStore.printProdPurchasePdf(this.store.invoice.id);
      } finally {
        this.loading = false;
      }
    },
  },
});
